import React from "react";
import { withI18n } from "react-i18next";
import styled from "styled-components";
import { Button, ButtonGroup, Toggle, Typography } from "../../../Common";
import BreadCrumb from "../../../Common/BreadCrumb";
import { ISessionTemplateInfoSheet } from "../../../../interfaces/ISessionTemplateInfoSheet";

const HeaderTemplate = (props: {
  breadCrumbList: any[];
  sessionTemplateInfoSheet?: ISessionTemplateInfoSheet;
  t: any;
  enabled: boolean;
  onEnabledChange: (event: any) => void;
  // onShowAddEditQuestions: () => void;
  // onSendToTalent: () => void;
  // onAttachAndSave: () => void;
  onSaveAndClose: () => void;
  onSaveAndSend: () => void;
  hasSentInfoSheet: boolean;
  pastAudition: boolean;
}) => {
  const {
    breadCrumbList,
    sessionTemplateInfoSheet,
    t,
    enabled,
    onEnabledChange: handleEnabledChange,
    pastAudition,
    onSaveAndClose,
    onSaveAndSend,
  } = props;
  return (
    <Wrapper>
      <HeaderBox>
        <BreadCrumb breadCrumbList={breadCrumbList} />
        <HeaderDetail>
          <Title>
            {sessionTemplateInfoSheet
              ? sessionTemplateInfoSheet.projectName
              : ""}
          </Title>
          <ActionsContainer>
            <Toggle
              checked={enabled}
              label={
                <StyledTypography
                  color="darkGrey"
                  component="span"
                  variant="h5"
                >
                  {enabled ? t("Info Sheet Enabled") : t("Info Sheet Disabled")}
                </StyledTypography>
              }
              onChange={handleEnabledChange}
            />
            {enabled && (
              <ButtonGroup>
                <Button
                  disabled={pastAudition || !sessionTemplateInfoSheet}
                  variant="secondary"
                  onClick={onSaveAndClose}
                >
                  {t("Save & Close")}
                </Button>
                <Button
                  disabled={pastAudition || !sessionTemplateInfoSheet}
                  onClick={onSaveAndSend}
                >
                  {t("Save & Send")}
                </Button>
              </ButtonGroup>
            )}
          </ActionsContainer>
        </HeaderDetail>
      </HeaderBox>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 95px;
  padding: ${(p) => p.theme.spacing(2, 0)};
  background: ${(p) => p.theme.white};
  box-shadow: inset 0 -1px 0 0 #e7e7f0;
`;

const HeaderBox = styled.div`
  max-width: 1440px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  margin: auto;
  padding: ${(p) => p.theme.spacing(0, 6)};
`;

const HeaderDetail = styled.div`
  min-height: ${p => p.theme.spacing(4.5)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: ${p => p.theme.spacing(2, 0, 0)};
`;

const Title = styled.div`
  color: ${(p) => p.theme.formField.color};
  font-size: ${(p) => p.theme["xxl-font-size"]};
  font-weight: ${(p) => p.theme["font-weight"]};
  line-height: 28px;
`;

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;

  & > :last-child { margin: ${p => p.theme.spacing(0, 0, 0, 2)}; }
`;

const StyledTypography = styled(Typography)`
  margin: 2px 0 1px;
`;

export default withI18n()(HeaderTemplate);
